import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { getDateSettingDetails } from '@bingads-webui-campaign/date-setting';

export const StartEndDates = ({
  startDate, endDate, isUseCampaignLevelDates, isDateLevelDisplayed,
}) => {
  const i18n = useContext(I18nContext);
  const dateSettings = useMemo(
    () => getDateSettingDetails(i18n, startDate, endDate, isUseCampaignLevelDates, isDateLevelDisplayed),
    [i18n, startDate, endDate, isUseCampaignLevelDates, isDateLevelDisplayed]
  );

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Start and end dates') }}>
      <Text>{dateSettings}</Text>
    </PropertyRow>
  );
};

StartEndDates.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  isUseCampaignLevelDates: PropTypes.bool,
  isDateLevelDisplayed: PropTypes.bool,
};

StartEndDates.defaultProps = {
  endDate: null,
  isUseCampaignLevelDates: false,
  isDateLevelDisplayed: false,
};
